import type { ReturnTypeUseMailSearch } from '../api/mail-search';
import type { ReturnTypeUseMail } from '../api/mails';

export enum MailTypeMessage {
  BROADCAST = 'BROADCAST',
  GROUP = 'GROUP',
}

export interface ComposeMailFormValues {
  subject: string;
  canReply: boolean;
  typeMessage: MailTypeMessage;
  toRecipients: ReturnTypeUseMailSearch[];
  partyId: number;
}

export type MailComposeProps = {
  onCloseCompose: () => void;
  defaultValues: Partial<
    ComposeMailFormValues & {
      body: string;
      attachments?: (NonNullable<
        ReturnTypeUseMail[number]['attachments']
      >[number] & {
        forwarded?: boolean;
        reuseFile?: boolean;
      })[];
    }
  >;
  activeProfileId: number;
  hasPermissionForSchoolInbox: boolean;
};
